module.exports = __webpack_public_path__ + "img/9788937883217.af1e7333.jpg";